import axios from '../../axios.js'


export default {
  fetchRecords({ commit }, payload) {
    // load files
    return new Promise((resolve, reject) => {
      axios
        .get("/files", {
          params: payload
        })
        .then(response => {
          commit("SET_FILES", response.data);
          commit("SET_PAGINATION", {
            currentPage: response.headers["x-pagination-page"],
            totalPage: response.headers["x-pagination-page-count"],
            pageTotal: response.headers["x-pagination-count"],
            totalItem: response.headers["x-pagination-total"]
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchRecord (context, docNo) {
    return new Promise((resolve, reject) => {
      axios.get(`/files/${docNo}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getSignedUrl (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/files/upload-signed-url?attachmentType=${payload.attachmentType}&name=${payload.name}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addFile(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/files', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
};
